import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const scrollToForm = () => {
    document.getElementById('lead-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center bg-hero-pattern bg-cover bg-center pt-20 overflow-hidden">
      <div className="absolute inset-0 bg-tile-pattern opacity-10"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-mission-dark/80 via-transparent to-transparent"></div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-spanish-ivory">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="inline-flex items-center gap-4 mb-8"
        >
          <div className="h-px w-8 bg-antique-gold"></div>
          <span className="text-antique-gold font-sans font-semibold uppercase tracking-[0.3em] text-xs">
            Corporate Holiday Parties
          </span>
          <div className="h-px w-8 bg-antique-gold"></div>
        </motion.div>

        <motion.h1 
          className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[1.1] mb-8 text-white"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          A Holiday Party <br className="hidden md:block" /> Isn’t Just a Party. <br />
          <span className="text-antique-gold italic block mt-2">It’s a Thank-You.</span>
        </motion.h1>

        <motion.p 
          className="text-lg md:text-xl font-light text-spanish-ivory/90 max-w-2xl mx-auto mb-12 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Celebrate the team that carried the year with a warm, elevated holiday event at Padua Weddings — a historic Spanish Revival estate designed for moments people actually remember.
        </motion.p>

        <motion.div 
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <button 
            onClick={scrollToForm}
            className="w-full sm:w-auto px-10 py-4 bg-mission-green text-spanish-ivory font-semibold rounded hover:bg-antique-gold hover:text-mission-dark transition-all duration-300 shadow-2xl border border-mission-green hover:border-antique-gold uppercase tracking-widest text-sm"
          >
            Check December Availability
          </button>
          <button 
            onClick={scrollToForm}
            className="w-full sm:w-auto px-10 py-4 bg-transparent border border-spanish-ivory/40 text-spanish-ivory font-semibold rounded hover:bg-spanish-ivory/10 transition-all duration-300 uppercase tracking-widest text-sm"
          >
            Book a Private Tour
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;